import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ReviewComponent} from '@shared/review/review.component';

const routes: Routes = [
    {
        path: '',
        component: ReviewComponent
    }
];

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forChild(routes),
        CommonModule
    ],
    exports: [RouterModule]
})
export class ReviewRoutingModule {
}
